import React from 'react'
import { FaGem, FaRegHeart, FaRing, FaStar, FaSmile, FaHandHoldingHeart } from "react-icons/fa"
import { motion } from "framer-motion";
import CTA from '../Hero/CTA'

const About = () => {
  return (
    <div>
      <div className="about-page">

        <section className="about-legacy py-5">
          <div className="container text-center">
            <motion.h2
              className="legacy-title mb-4"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              The Legacy of Tanishq
            </motion.h2>

            <motion.p
              className="legacy-desc mb-3"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Born under the prestigious <em>Tata Group</em>, <strong>Tanishq</strong> is part of <em>Titan Company Limited</em>, one of India’s most trusted lifestyle companies. Since its inception in the 1990s, Tanishq has redefined the jewellery industry with innovation, transparency, and craftsmanship.
            </motion.p>

            <motion.p
              className="legacy-desc"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              With a focus on <em>purity, design excellence, and customer trust</em>, Tanishq has become a symbol of emotional connection — celebrating life’s milestones, traditions, and everyday beauty.
            </motion.p>
          </div>
        </section>

        <motion.section
          className="legacy-local py-5"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <div className="container">
            <div className="legacy-local-card p-5 text-center">
              <p className="legacy-local-text">
                <strong>At JJ Associates – Tanishq Rajkot</strong>, we bring this national legacy to our city with pride.
                From heritage gold designs to modern diamond jewellery, our store showcases the full spectrum of
                <strong> Tanishq’s artistry</strong>.
              </p>
            </div>
          </div>
        </motion.section>

        {/* OFFERINGS SECTION */}
        <section className="offerings-section py-5">
          <div className="container">
            <h2 className="offerings-title text-center mb-5">Our Offerings</h2>

            <motion.div
              className="row justify-content-center g-4"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={{
                visible: {
                  transition: {
                    staggerChildren: 0.2
                  }
                }
              }}
            >

              {/* Gold Jewellery */}
              <motion.div
                className="col-md-3 col-sm-6"
                variants={{
                  hidden: { opacity: 0, y: 50 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
                }}
              >
                <div className="offering-card text-center p-4">
                  <FaGem className="offering-icon" />
                  <h5>Gold Jewellery</h5>
                  <p>Crafted with 100% BIS Hallmarked purity</p>
                </div>
              </motion.div>

              {/* Diamond Collections */}
              <motion.div
                className="col-md-3 col-sm-6"
                variants={{
                  hidden: { opacity: 0, y: 50 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
                }}
              >
                <div className="offering-card text-center p-4">
                  <FaStar className="offering-icon" />
                  <h5>Diamond Collections</h5>
                  <p>Ethically sourced, precisely cut, and certified</p>
                </div>
              </motion.div>

              {/* Wedding & Bridal Sets */}
              <motion.div
                className="col-md-3 col-sm-6"
                variants={{
                  hidden: { opacity: 0, y: 50 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
                }}
              >
                <div className="offering-card text-center p-4">
                  <FaRing className="offering-icon" />
                  <h5>Wedding & Bridal Sets</h5>
                  <p>Celebrating love, joy, and cherished tradition</p>
                </div>
              </motion.div>

              {/* Everyday Jewellery */}
              <motion.div
                className="col-md-3 col-sm-6"
                variants={{
                  hidden: { opacity: 0, y: 50 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
                }}
              >
                <div className="offering-card text-center p-4">
                  <FaRegHeart className="offering-icon" />
                  <h5>Everyday Jewellery</h5>
                  <p>Elegant pieces for your daily sparkle always</p>
                </div>
              </motion.div>

            </motion.div>
          </div>
        </section>

        {/* OUR PROMISE SECTION - REDESIGNED DARK BACKGROUND */}
        <div className="promise-section-hero-dark">
          <section className="container">
            <div className="promise-row row align-items-center">

              {/* Left Column - Title & Description */}
              <motion.div
                className="col-12 col-lg-8"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                <h4 className="promise-subtitle">Our Promise</h4>
                <h3 className="promise-title">
                  At JJ Associates – Tanishq Rajkot, we uphold a legacy of trust and brilliance.
                </h3>
                <p className="promise-desc">
                  From purity in every gold piece to exceptional customer care, we ensure that
                  every visit to our store is memorable. Experience craftsmanship, authenticity,
                  and elegance in each jewellery creation.
                </p>
              </motion.div>

              {/* Right Column - Features */}
              <motion.div
                className="col-12 col-lg-4"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={{
                  visible: { transition: { staggerChildren: 0.2 } }
                }}
              >
                <div className="promise-features d-flex flex-column gap-3">

                  {/* Feature Items */}
                  {[
                    { icon: <FaGem className="feature-icon" />, text: "Transparency in Purity & Pricing" },
                    { icon: <FaSmile className="feature-icon" />, text: "Exceptional In-Store Experience" },
                    { icon: <FaHandHoldingHeart className="feature-icon" />, text: "After-Sales Care & Support" }
                  ].map(({ icon, text }, index) => (
                    <motion.div
                      key={index}
                      className="feature-item d-flex justify-content-between align-items-center"
                      variants={{
                        hidden: { opacity: 0, y: 30 },
                        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
                      }}
                    >
                      <div className="feature-icon-text d-flex align-items-center gap-2">
                        {icon}
                        <span>{text}</span>
                      </div>
                    </motion.div>
                  ))}

                </div>
              </motion.div>

            </div>
          </section>
        </div>

        <CTA />

      </div>
    </div>
  )
}

export default About